export default {"src":"/_next/static/media/halal.92150bcf.svg","height":16,"width":16};